import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiAlertModule, TuiRootModule } from "@taiga-ui/core";
import { KwikUICustomModule } from "../public_api";
import { KwikUICoreModule } from "./components/core/core.module";
import { KwikUIMiscModule } from "./components/misc/misc.module";
import { KwikUIComponent } from "./kwikui.component";

@NgModule({
  declarations: [KwikUIComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KwikUICoreModule,
    KwikUICustomModule,
    KwikUIMiscModule,
    TuiRootModule,
    TuiAlertModule
  ],
  exports: [
    KwikUIComponent,
    KwikUICoreModule,
    KwikUICustomModule,
    KwikUIMiscModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KwikUIModule {}
